var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4153_1204",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4153_1204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4987 12.2493L12.832 9.91602L12.0154 9.09935L11.082 10.0327V7.59727H9.91536V10.0327L8.98203 9.09935L8.16536 9.91602L10.4987 12.2493ZM8.16536 13.9993V12.8327H12.832V13.9993H8.16536ZM3.4987 11.666C3.17786 11.666 2.90321 11.5518 2.67474 11.3233C2.44627 11.0948 2.33203 10.8202 2.33203 10.4993V2.33268C2.33203 2.01185 2.44627 1.7372 2.67474 1.50872C2.90321 1.28025 3.17786 1.16602 3.4987 1.16602H7.58203L11.082 4.66602V6.4306H9.91536V5.24935H6.9987V2.33268H3.4987V10.4993H6.9987V11.666H3.4987Z",
    fill: "#222222"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSave);
export default __webpack_public_path__ + "static/media/FileSave.e75b22e561463f0d738ce42636f1bc7e.svg";
export { ForwardRef as ReactComponent };